// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39fxo","rootNoMargin":"styles_rootNoMargin__38mk7"};